module.exports = __webpack_public_path__ + "media/3x/L-b6854f7a.png";